module.exports = __webpack_public_path__ + "img/nt53-00-80-1_1.prt.161f45d4.jpg";